import * as d3 from 'd3';

import {
  xyify,
  scale,
  translation
} from 'util/formatters/data-viz/d3-helpers';

// lodash
import { every, isFinite } from 'lodash';

const appendVizMap = ({ viz, mapGeoJson, config }) => {
  const width = config.width;
  const height = config.height;

  // initialize projection and path
  const projection = d3.geoMercator();
  const path = d3.geoPath().projection(projection);

  // set initial projection
  projection.scale(1).translate([0, 0]);

  /* bounds will be transformed to an object with keys xMax, yMax, xMin, yMin
     xMin is the minimum x-coordinate, yMin is the minimum y-coordinate, xMax is maximum x-coordinate, and yMax is the
     maximum y-coordinate. https://github.com/d3/d3-geo/blob/master/README.md#path_bounds */

  const bounds = xyify(path.bounds(mapGeoJson));
  if (every(bounds, isFinite)) {
    // calculate scale and translate
    const scaling = scale({
      scaleFactor: 0.95,
      bounds: bounds,
      width: width,
      height: height
    });

    const translationing = translation({
      translationScale: scaling,
      bounds: bounds,
      width: width,
      height: height
    });

    // reset projection
    projection
    .scale(scaling)
    .translate(translationing);

    const features = viz.selectAll('path')
    .data(mapGeoJson.features)
    .enter()
    .append('path')
    .attr('d', path);

    features.attr('class', 'data-path');
    features.attr('fill', (d) => { return d.displayMeta.fill; });
    features.attr('stroke', (d) => { return d.displayMeta.stroke; });
    features.attr('stroke-width', (d) => { return d.displayMeta.strokeWidth; });
    features.attr('data-test-id', 'script-field-thumbnail');
  }
  return viz;
};

export default appendVizMap;
